export class TelerikUtility {

    public static getDataGridFromContainer(dataGridContainerSelector: string | JQuery<any>) {
        return jQuery(dataGridContainerSelector).find("[data-gridid]");
    }

    public static refreshDataGridView(dataGridContainerSelector: any) {
        let iqaGridElement = this.getDataGridFromContainer(dataGridContainerSelector);
        let gridId = iqaGridElement.data("gridid");

        let radGrid: Telerik.Web.UI.RadGrid = $find(gridId);
        let masterTable = radGrid.get_masterTableView();
        masterTable.rebind();
    }

    public static removeAllNumericTextBoxDisplayFormatting(controlSelector: string = "input.riTextBox") {
        let self = this;

        jQuery(controlSelector).each(function () {
            let tControl: Telerik.Web.UI.RadWebControl = $find(this.id);
            if (tControl != null) {
                let tControlClassName = tControl.constructor["__typeName"];
                if (tControlClassName == "Telerik.Web.UI.RadNumericTextBox") {
                    self.removeNumericTextBoxDisplayFormatting(this.id);
                }
            }
        });
    }

    public static removeNumericTextBoxDisplayFormatting(elementId: string) {
        let tNumericControl: Telerik.Web.UI.RadInputControl = $find(elementId);

        // trigger change event after load
        tNumericControl.add_valueChanged((sender) => { sender.set_displayValue(sender.get_value()); });
        tNumericControl.raise_valueChanged(tNumericControl.get_value(), Number.MIN_VALUE);
    }

    public static getTabStrip(parentSelector: string = ""): Telerik.Web.UI.RadTabStrip {
        let jTabStrip = this.getTabStripElement(parentSelector);
        let tTabStrip = $find<Telerik.Web.UI.RadTabStrip>(jTabStrip.attr("id"));

        return tTabStrip;
    }

    public static getTabStripUniqueId(parentSelector: string = ""): string {
        let uniqueId = "";
                
        let jTabStrip = this.getTabStripElement(parentSelector);
        let jLinks = jTabStrip.parent().siblings("a");
        if (jLinks.length > 0) {
            uniqueId = jLinks.attr("id");
        }

        return uniqueId;
    }

    public static getTelerikControlValue(tElement: Telerik.Web.UI.RadWebControl) {
        let value;

        // check specific options or use the generic type to cover all possible options
        if (this.isTelerikDateControl(tElement)) {
            value = (<Telerik.Web.UI.RadDateTimePicker>tElement).get_selectedDate();
        } else if (tElement["get_value"] != null) {
            value = tElement["get_value"]();
        }

        return value;
    }

    public static setTelerikControlValue(tElement: Telerik.Web.UI.RadWebControl, newValue: any) {
        // check specific options or use the generic type to cover all possible options
        if (this.isTelerikDateControl(tElement)) {
            (<Telerik.Web.UI.RadDateTimePicker>tElement).set_selectedDate(newValue);
        } else if (tElement["set_value"] != null) {
            tElement["set_value"](newValue);
        }
    }

    public static isTelerikDateControl(tElement: Telerik.Web.UI.RadWebControl) {
        return tElement["_dateInput"] != null;
    }

    private static getTabStripElement(parentSelector: string = "") {
        return jQuery(parentSelector + " .RadTabStrip");
    }

}